import { ref, reactive, toRefs } from 'vue-demi';
import { isLegacyConnected } from '@/platform/utils/legacy-connector';

const state = reactive({
  isLegacyConnected: ref(false),
});

export default () => {
  const check = () => {
    state.isLegacyConnected = isLegacyConnected();
  };
  check();

  const postMessageToHybrid = (messageEvent) => {
    if (state.isLegacyConnected) {
      window.parent.postMessage(messageEvent);
    }
  };

  return {
    check,
    postMessageToHybrid,
    ...toRefs(state),
  };
};
